module.exports = __webpack_public_path__ + "img/no_preview.b4e999c2.jpg";